import React from 'react';

export default function TrustBar({ isFooter = false }) {
  return (
    <div className="bg-stone">
      <div className="max-width mx-auto">
        <div className={isFooter ? 'py-6 pt-12' : 'py-6 lg:pt-12 lg:px-12'}>
          <div className="text-lg font-sonoma font-regular mb-6 w-[400px] max-w-full">
            Trusted By Thousands of Organizations Across the Globe.
          </div>
          <img
            data-src="/website/images/customers.png"
            className="m-0 mx-auto lozad"
            style={{ aspectRatio: '528 / 25' }}
          />
        </div>
      </div>
    </div>
  );
}
